import { useLocation, useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';

/**
 * Mobile-only floating action button for the primary "add transaction" flow.
 * Matches kit_mobile.html: purple circle, ~52px, above the bottom nav.
 *
 * Hidden on `md+` and on detail pages where a destructive/contextual action
 * already lives (mortgage detail, recurring detail, etc).
 */
const HIDDEN_PATH_PREFIXES = [
  '/transactions/', // detail
  '/recurring/',
  '/debts/mortgage/',
  '/accounts/',
  '/admin',
  '/settings',
  '/login',
  '/register',
];

export function MobileFab() {
  const location = useLocation();
  const navigate = useNavigate();

  const shouldHide = HIDDEN_PATH_PREFIXES.some((p) => location.pathname.startsWith(p));
  if (shouldHide) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/transactions?action=create')}
      className="md:hidden fixed right-4 bottom-20 z-40 flex items-center justify-center rounded-full bg-brand-purple-600 text-white shadow-[0_12px_24px_rgba(124,58,237,0.4)] hover:bg-brand-purple-700 active:scale-95 transition-all"
      style={{ width: 52, height: 52 }}
      aria-label="Add transaction"
    >
      <Plus className="h-6 w-6" strokeWidth={2.5} />
    </button>
  );
}
